// Where the ChatGPT proof line links: our own announcement, because the plugin's public listing isn't
// open yet. Swap in the ChatGPT link once it's public.
export const chatgptProofPath = '/changelog/2026-10-30-workspace369-plugin-for-chatgpt';
